import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./css/HistoryOrderList.scss";
import { useOrderList } from "./hook/useOrderList";
import { OrderItemList } from "./OrderItemList";
import { subMonths } from "date-fns";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";

export const HistoryOrderList = () => {
    const monthIntervalList = [3, 6, 12];

    const { orderList, getOrdersState, getOrders } = useOrderList();
    const [selectedMonth, setSelectedMonth] = useState(monthIntervalList[2]);
    const { t } = useTranslation(["order", "glossary"]);

    useEffect(() => {
        getOrders(subMonths(new Date(), selectedMonth).toISOString());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMonth]);

    return (
        <Fragment>
            <Grid className="historyOrder-header" container spacing={2}>
                <Grid item>
                    <InputLabel htmlFor="history-helper">
                        <Typography color="primary" variant="h2">
                            {t("order:myOrderHistory")}
                        </Typography>
                    </InputLabel>
                </Grid>
                <Grid item>
                    <Select
                        aria-label="Select filter"
                        disableUnderline
                        fullWidth
                        id="history-helper"
                        value={selectedMonth}
                        variant="filled"
                        onChange={(event) => setSelectedMonth(parseInt(event.target.value as string))}
                    >
                        {monthIntervalList.map((month) => (
                            <MenuItem key={month} value={month}>
                                {t("glossary:lastXMonths", { monthsNumber: month })}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            <HandleErrorAndLoading isLoading={getOrdersState.isLoading}>
                {orderList.length !== 0 && (
                    <Grid container spacing={2}>
                        {orderList.map((order) => (
                            <Grid item key={order.reference} xs={12}>
                                <Card elevation={2}>
                                    <CardContent>
                                        <OrderItemList offerList={order.offers} order={order} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
                {orderList.length === 0 && (
                    <Card elevation={2}>
                        <CardContent>
                            <Typography align="center" color="textSecondary" variant="body1">
                                {t("order:noOrdersPeriod")}
                            </Typography>
                        </CardContent>
                    </Card>
                )}
            </HandleErrorAndLoading>
        </Fragment>
    );
};
